/**
 * Golf Practice Drill Reducers
 */
import {
    PRACTICEDRILL_ACTION,
    ALL_PRACTICEDRILL,
    ADD_PRACTICEDRILL,
    FETCH_PRACTICEDRILL,
    EDIT_PRACTICEDRILL,
    DELETE_PRACTICEDRILL
 } from 'Actions/types';
 
 
 const INIT_STATE = {
    practicedrilllist:[],
    particulardrilll:[],
    loading: false,
 };
 
 export default (state = INIT_STATE, action) => {
     switch (action.type) {
         
        case PRACTICEDRILL_ACTION:
            return { ...state, loading: true };       

        case ALL_PRACTICEDRILL:
            return { ...state, loading: false, practicedrilllist: action.payload };     
            
        case ADD_PRACTICEDRILL:
            return { ...state, loading: false };     
         
        case FETCH_PRACTICEDRILL:
            return { ...state, loading: false, particulardrilll: action.payload };  
            
        case EDIT_PRACTICEDRILL:
            return { ...state, loading: false }; 
            
        case DELETE_PRACTICEDRILL:
            return { ...state, loading: false };     
        
        default: return { ...state };

     }
 }